export const GoogleAnalyticsMixins = {
	methods: {
		/**
		 * Send a Custom Event
		 * @param action - to contain the type of action executed.
		 * @param eventCategory - name of category
		 * @param eventLabel - name of label
		 * @param eventValue - Non-Negative number to be passed to GA
		 *
		 * please See Docs for more info:
		 * @devGuide https://developers.google.com/analytics/devguides/collection/analyticsjs/events
		 * */
		sendEventTrackingToGA(action, eventCategory, eventLabel, eventValue) {
			this.$gtag.event(action, {
				event_category: eventCategory,
				event_label: eventLabel,
				value: eventValue
			});
		}
	}
}